var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { toast as reactToastify, Slide, ToastContainer } from 'react-toastify';
var containerId;
function show(message, options) {
    reactToastify.dismiss(containerId);
    containerId = reactToastify(message, __assign(__assign({}, options), { transition: Slide, position: 'top-right', autoClose: 3000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true }));
}
export function toastShowSuccess(message) {
    show(message, { type: 'success' });
}
export function toastShowError(message) {
    show(message, { type: 'error' });
}
export var toast = {
    showSuccess: toastShowSuccess,
    showError: toastShowError,
    ToastContainer: ToastContainer,
};
